<template>
  <SoNavigationDrawer :links="links"></SoNavigationDrawer>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { StatusType } from "@/types/Status"
  import SoNavigationDrawer from "@/components/navigation/SoNavigationDrawer.vue"

  export default defineComponent({
    components: {
      SoNavigationDrawer,
    },
    computed: {
      links() {
        const accountNumber = this.$route.params.accountNumber
        return [
          {
            icon: "overview",
            title: "Overview",
            to: `/customer/${accountNumber}`,
          },
          {
            icon: "email",
            title: "Timeline",
            to: `/customer/${accountNumber}/timeline`,
          },
          {
            icon: "chart",
            title: "Financials",
            to: `/customer/${accountNumber}/financials`,
          },
          {
            icon: "refresh",
            title: "Renewals",
            to: `/customer/${accountNumber}/renewals`,
          },
          {
            icon: "meter",
            title: "Meterpoints",
            to: `/customer/${accountNumber}/meterpoints`,
          },
          {
            icon: "signals",
            title: "Smart Devices",
            to: `/customer/${accountNumber}/smart-devices`,
            badge: {
              active: true,
              status: "neutral" as StatusType,
              content: "beta",
            },
          },
          {
            icon: "home",
            title: "Moving Home",
            to: `/customer/${accountNumber}/cot`,
          },
          {
            icon: "alert-circle",
            title: "Complaints",
            to: `/customer/${accountNumber}/complaints`,
            badge: {
              active: !!useCurrentAccountStore().hasOpenComplaint.data,
              status: "critical" as StatusType,
            },
          },
          {
            icon: "file-text",
            title: "Agreements",
            to: `/customer/${accountNumber}/agreements`,
          },
          {
            icon: "list",
            title: "Junifer",
            to: `/customer/${accountNumber}/junifer`,
          },
        ]
      },
    },
  })
</script>
